import { ActionsUnion, createAction } from "@redux/helpers";
import {
  FiltersPayload,
  FiltersResponseType,
  StylingFiltersData
} from "@type/index";

export const GET_STYLING_FILTERS =
  "[styling filter] get styling filter request";
const GET_STYLING_FILTERS_SUCCESS =
  "[styling filter] get styling filter success";
const GET_STYLING_FILTERS_LOADING =
  "[styling filter] get styling filter loading";
const INIT_STYLING_FILTERS = "[styling filter] init styling filters";
const SET_IS_RELOAD_FILTERS = "[styling filter] set reload styling filters";
export const GET_STYLING_FILTERS_CATEGOTY =
  "[styling filter category] get styling category filter request";
const GET_STYLING_FILTERS_CATEGOTY_LOADING =
  "[styling filter category] get styling category filter loading";
export const GET_STYLING_FILTERS_COORDINATE =
  "[styling filter coordinate] get styling coordinate filter request";
const GET_STYLING_FILTERS_COORDINATE_LOADING =
  "[styling filter coordinate] get styling coordinate filter loading";

export const Actions = {
  getStylingFilters: (payload: FiltersPayload) =>
    createAction(GET_STYLING_FILTERS, payload),
  getStylingFiltersSuccess: (payload: FiltersResponseType) =>
    createAction(GET_STYLING_FILTERS_SUCCESS, payload),
  getStylingFiltersLoading: (payload: boolean) =>
    createAction(GET_STYLING_FILTERS_LOADING, payload),
  initStylingFilters: () => createAction(INIT_STYLING_FILTERS),
  setIsReloadFilters: (payload: boolean) =>
    createAction(SET_IS_RELOAD_FILTERS, payload),
  getStylingFiltersCategory: (payload: FiltersPayload) =>
    createAction(GET_STYLING_FILTERS_CATEGOTY, payload),
  getStylingFiltersCategoryLoading: (payload: boolean) =>
    createAction(GET_STYLING_FILTERS_CATEGOTY_LOADING, payload),
  getStylingFiltersCoordinate: (payload: FiltersPayload) =>
    createAction(GET_STYLING_FILTERS_COORDINATE, payload),
  getStylingFiltersCoordinateLoading: (payload: boolean) =>
    createAction(GET_STYLING_FILTERS_COORDINATE_LOADING, payload)
};

type ActionType = ActionsUnion<typeof Actions>;

export type State = StylingFiltersData;

const initialState = {
  loading: true,
  categoryList: [],
  coordinationList: [],
  featureList: [],
  hashtagList: [],
  isReloadFilters: false
};

export default (state: State = initialState, action: ActionType): State => {
  switch (action.type) {
    case GET_STYLING_FILTERS_SUCCESS:
      return {
        ...state,
        categoryList: [
          ...(action.payload.styleCategories || state.categoryList)
        ],
        coordinationList: [
          ...(action.payload.tagCategories || state.coordinationList)
        ],
        featureList: [...(action.payload.features || state.featureList)],
        hashtagList: [...(action.payload.hashtags || state.hashtagList)],
        loading: false
      };
    case GET_STYLING_FILTERS_LOADING:
      return {
        ...state,
        loading: action.payload
      };
    case INIT_STYLING_FILTERS:
      return {
        ...state,
        ...initialState
      };
    case SET_IS_RELOAD_FILTERS:
      return {
        ...state,
        isReloadFilters: action.payload
      };
    default:
      return state;
  }
};
